/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<g fill-rule="nonzero"><path pid="0" d="M26.476 0c-2.216 0-1.47 4.736-1.47 4.736s-4.737 13.06-9.267 16.541c-.971 1.02-1.578 2.147-1.961 3.069-.087.225-.166.441-.235.637-.303.618-.951 1.569-2.334 2.402l4.53 19.699s7.011.912 14.041.765c2.814.225 5.795.245 8.168-.265 8.06-1.716 6.04-7.334 6.04-7.334 4.343-3.265 1.872-7.344 1.872-7.344 3.864-4.03.069-7.413.069-7.413s2.089-3.255-.607-5.716c-3.364-3.079-12.492-1.029-12.492-1.029-.638.108-1.314.244-2.039.421 0 0-3.157 1.471 0-8.109C33.958 1.481 28.692 0 26.476 0zM12.485 45.662L9.053 29.357c-.197-.933-1.138-1.697-2.089-1.697H.414l-.01 19.688h10.697c.961.01 1.579-.754 1.384-1.686z"/></g>'
}
